import { createCursorListResponseSchema, cursorPaginationInputSchema } from "../util/cursorPagination.mjs";
import { boostSortFieldSchema, boostStatusSchema, extraPackageBoostSchema } from "./schemas.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/extraPackageBoost/user.ts
/**
* Inlined helpers from the server's `api/orpc/utils/baseTypes.ts`. Both
* are pure-zod and don't depend on anything else in pixai-server. Kept
* here so the contract package owns the shape it validates against.
*/
const ensureArray = (schema) => schema.or(z.array(schema)).transform((val) => Array.isArray(val) ? val : [val]);
const sortDirectionSchema = z.enum(["asc", "desc"]);
const createSortQueryFields = (fieldSchema) => ({
	sortField: fieldSchema.optional(),
	sortDirection: sortDirectionSchema.optional().default("desc")
});
const listMyExtraPackageBoostsInputSchema = cursorPaginationInputSchema.extend({
	status: ensureArray(boostStatusSchema).optional(),
	...createSortQueryFields(boostSortFieldSchema)
});
const listMyExtraPackageBoostsOutputSchema = createCursorListResponseSchema(extraPackageBoostSchema);
const getExtraPackageBoostByCodeInputSchema = z.object({ code: z.string().min(1) });
const getExtraPackageBoostByCodeOutputSchema = extraPackageBoostSchema;
const extraPackageBoostContract = oc.tag("ExtraPackageBoost").router({
	listMyBoosts: oc.route({
		method: "GET",
		path: "/extra-package-boosts/"
	}).input(listMyExtraPackageBoostsInputSchema).output(listMyExtraPackageBoostsOutputSchema),
	getByCode: oc.route({
		method: "GET",
		path: "/extra-package-boosts/{code}"
	}).input(getExtraPackageBoostByCodeInputSchema).output(extraPackageBoostSchema).errors({ BOOST_NOT_FOUND: {
		status: 404,
		message: "Boost not found"
	} })
});
//#endregion
export { extraPackageBoostContract, getExtraPackageBoostByCodeInputSchema, getExtraPackageBoostByCodeOutputSchema, listMyExtraPackageBoostsInputSchema, listMyExtraPackageBoostsOutputSchema };
